import React, { Dispatch, SetStateAction, SyntheticEvent, useState } from 'react';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { DataAutocompleteFilterType } from 'shared/ui/Filter/model';

type AutocompleteFilterType = {
  data: DataAutocompleteFilterType[];
  label: string;
  setSearch?: Dispatch<SetStateAction<string>>;
  handleSelectedValuesChange: (values: DataAutocompleteFilterType[]) => void;
  isLoading?: boolean;
  width?: string;
  style?: object;
  loadingText?: string;
};

export const AutocompleteFilter = ({
  data,
  setSearch,
  label,
  handleSelectedValuesChange,
  isLoading,
  loadingText,
  style,
}: AutocompleteFilterType) => {
  const [selectedValues, setSelectedValues] = useState<DataAutocompleteFilterType[]>([]);
  const [open, setOpen] = useState<boolean>(false);

  const handleChange = (event: SyntheticEvent, values: DataAutocompleteFilterType[]) => {
    setSelectedValues(values);
    handleSelectedValuesChange(values);
  };

  const onOpenHandler = () => {
    setOpen(true);
  };

  const onCloseHandler = () => {
    setOpen(false);
  };

  return (
    <Autocomplete
      multiple
      limitTags={1}
      open={open}
      onOpen={onOpenHandler}
      onClose={onCloseHandler}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      id="activity-select"
      options={data || []}
      loadingText={loadingText || 'По вашему запросу ничего не найдено'}
      disableCloseOnSelect
      noOptionsText="По вашему запросу ничего не найдено"
      loading={isLoading}
      value={selectedValues}
      onChange={handleChange}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option.name}
        </li>
      )}
      sx={style}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          onChange={(e) => setSearch?.(e.target.value)}
        />
      )}
    />
  );
};
